// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.leaflet-layer,
.leaflet-control-zoom-in,
.leaflet-control-zoom-out,
.leaflet-control-attribution {
  filter: invert(100%) hue-rotate(180deg) brightness(95%) contrast(90%);
}

.leaflet-container {
    background: #121212;
    border-radius: 25px;
}`, "",{"version":3,"sources":["webpack://./src/containers/NewProject/leafletStyles.css"],"names":[],"mappings":"AAAA;;;;EAIE,qEAAqE;AACvE;;AAEA;IACI,mBAAmB;IACnB,mBAAmB;AACvB","sourcesContent":[".leaflet-layer,\n.leaflet-control-zoom-in,\n.leaflet-control-zoom-out,\n.leaflet-control-attribution {\n  filter: invert(100%) hue-rotate(180deg) brightness(95%) contrast(90%);\n}\n\n.leaflet-container {\n    background: #121212;\n    border-radius: 25px;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
